// extracted by mini-css-extract-plugin
module.exports = {"button":"styles-module__button___1Z9os"};